@if (!data.submitAction&&!data.qrCodeStatus) {
<div class="dialog-content home-router-dialog">
  <!--btn:關閉按鈕-->
  @if (data.showCloseButton) {
  <button mat-button (click)="close()" class="dialog-close-btn">
    <img src="assets/img/i-close.svg" alt="" />
  </button>
  }

  <!--title 標題-->
  <h1 class="dialog-title">{{ 'home-router-dialog.title' | translate }}</h1>

  <!--dialog 內容-->
  <div mat-dialog-content class="dialog-body">
    <p class="dialog-description">
      {{ 'home-router-dialog.message' | translate }}<br>
    </p>

    <!-- 重點提示區塊 -->
    <div class="highlight-box">
      <div class="highlight-header">
        <img src="assets/img/Shield_Check.png" alt="" class="check-icon" />
        <span>{{ 'home-router-dialog.highlight-item-1' | translate }}</span>
      </div>
      <div class="highlight-header">
        <img src="assets/img/calendar.png" alt="" class="check-icon" />
        <span>{{ 'home-router-dialog.highlight-item-2' | translate }}</span>
      </div>
    </div>


    <button mat-button class="btn-fill-primary btn-size-l" (click)="data.action()">
      {{ 'home-router-dialog.button-text' | translate }}
    </button>

    <div class="btn-wrapper">
      <button mat-button class="btn-text-underline btn-size-s" (click)="goToOldWeb()">
        {{ 'home-router-dialog.button-text-2' | translate }}
      </button>
    </div>
  </div>
</div>
}
@if (data.submitAction&&!data.qrCodeStatus) {
<div class="dialog-content home-router-dialog">
  <!--btn:關閉按鈕-->

  @if (data.showCloseButton) {
  <button mat-button (click)="close()" class="dialog-close-btn">
    <img src="assets/img/i-close.svg" alt="" />
  </button>
  }

  <!--title 標題-->

  <div class="page-title-block-icon">
    <img width="56" height="56"
      [src]="data.status==='true'?'assets/img/i-success-fill-green.svg':'assets/img/special-warning.png'" alt="" />
    <h1 class="dialog-title">{{ data.title | translate }}</h1>

  </div>

  <!--dialog 內容-->
  <div mat-dialog-content class="dialog-body">
    <p class="dialog-description">
      {{ data.message | translate }}<br>
    </p>

    @if(data?.buttonText){
    <div class="btn-wrapper">
      <button mat-button class="btn-fill-primary btn-size-l" (click)="data.closeAction()">
        {{ data?.buttonText?? '' | translate }}
      </button>
    </div>
    }
    @if(data?.buttonText2){

    <div class="btn-wrapper">
      <button mat-button class=" btn-size-l" (click)="data.action()">
        <span style="text-decoration: underline;">{{ data?.buttonText2?? '' | translate }}</span>
      </button>
    </div>
    }
  </div>
</div>

}
@if (data.qrCodeStatus&&data.submitAction) {
<div class="dialog-content home-router-dialog">
  <button mat-button (click)="close()" class="dialog-close-btn">
    <img src="assets/img/i-close.svg" alt="" />
  </button>

  <!--title 標題-->
  @if(!safeQrCodeUrl){
  <div class="page-title-block-icon">
    <img width="56" height="56"
      [src]="data.status==='true'?'assets/img/i-success-fill-green.svg':'assets/img/special-warning.png'" alt="" />
    <h1 class="dialog-title">{{ data.title | translate }}</h1>

  </div>
  }

  <!--dialog 內容-->
  <div mat-dialog-content class="dialog-body">
    <p class="dialog-description">
      {{ data.message | translate }}<br>
    </p>
    <!-- 關鍵：如果資料中有圖片則顯示 -->
    @if(safeQrCodeUrl){
    <div class="qr-wrapper" [class.disabled]="isQrCodeDisabled"
      style="position: relative;  text-align: center; margin: 20px auto; width: 200px; height: 200px;">
      <img [src]="safeQrCodeUrl" alt="簽署 QR Code" style="width: 100%; height: 100%; display: block;">

      @if(isQrCodeDisabled) {
      <button type="button" class="refresh-btn" (click)="onRefresh()"
        style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); border: none; background: #00c1a2; width: 44px; height: 44px; border-radius: 50%; cursor: pointer; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 8px rgba(0,0,0,0.2); z-index: 2;">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67" />
        </svg>
      </button>
      }
    </div>

    <div class="countdown-timer" style="color: #666; font-weight: 500; margin-top: 10px; text-align: center;">
      QR Code 將於 {{ countdownText }} 後失效
    </div>
    }

    <div class="warning-box"
      style="color: #D26214;display: flex; background: #fff2f0;  padding: 8px; border-radius: 8px; font-size: 15px; justify-content: center;margin-top: 10px;">
      <img  width="21" height="21" src="/assets/img/i-warn-fill.svg" alt="alert">
      <span>於手機上完成簽署後，再關閉此視窗。</span>
    </div>
    @if(data?.buttonText){
    <div class="btn-wrapper">
      <button mat-button class="btn-fill-primary btn-size-l" (click)="data.closeAction()">
        {{ data?.buttonText?? '' | translate }}
      </button>
    </div>
    }
    @if(data?.buttonText2){
    <div class="btn-wrapper">
      <button mat-button class="btn-fill-primary btn-size-l" (click)="data.action()">
        {{ data?.buttonText2?? '' | translate }}
      </button>
    </div>
    }
  </div>
</div>
}